<script>
    export let values;
    export let frozenValues;

    function isDifferent(values, frozenValues) {
        return (frozenValues.smoking !== values.smoking)
            || (frozenValues.recall !== values.recall)
            || (frozenValues.fmbs !== values.fmbs)
            || (frozenValues.ppd !== values.ppd);
    }

</script>

<div>
    {#if isDifferent(values, frozenValues)}
        <p>Changes:</p>
        <ul>
            {#if (frozenValues.smoking < values.smoking)}
            <li>
                Increase smoking from {frozenValues.smoking} to {values.smoking} cigarettes/day.
            </li>
            {:else if (frozenValues.smoking > values.smoking)}
            <li>
                Reduce smoking from {frozenValues.smoking} to {values.smoking} cigarettes/day.
            </li>
            {/if}

            {#if (frozenValues.recall < values.recall)}
            <li>
                Increase recall interval from {frozenValues.recall} to {values.recall} months.
            </li>
            {:else if (frozenValues.recall > values.recall)}
            <li>
                Reduce recall interval from {frozenValues.recall} to {values.recall} months.
            </li>
            {/if}

            {#if (frozenValues.fmbs < values.fmbs)}
                <li>
                    Increase bleeding score {frozenValues.fmbs} to {values.fmbs}%.
                </li>
            {:else if (frozenValues.fmbs > values.fmbs)}
                <li>
                    Reduce bleeding score from {frozenValues.fmbs} to {values.fmbs}%.
                </li>
            {/if}

            {#if (frozenValues.ppd < values.ppd)}
                <li>
                    Increase number of deep pockets from {frozenValues.ppd} to {values.ppd}.
                </li>
            {:else if (frozenValues.ppd > values.ppd)}
                <li>
                    Reduce number of deep pockets from {frozenValues.ppd} to {values.ppd}.
                </li>
            {/if}
        </ul>
    {/if}
</div>